import React from 'react';

function Layout({ children }: any) {
  return <div>{children}</div>;
}

export default Layout;
